<template>
  <div class="distribution pad30">
    <h2 class="f18 fb normal gray_2">推荐返利</h2>
    <div class="mar20-tb flex">
      <div class="flex flex-column h120 justify-center pad50-lr border-r">
        <div class="f36 mar10-b text-left">{{ info.recommendRewardNum || 0 }}</div>
        <div class="f14">
          <span class="gray6">累计收益（积分）</span>
          <span class="red mar10-l pointer" @click="openHome">积分明细</span>
        </div>
      </div>
      <div class="flex flex-auto">
        <div class="flex flex-column h120 justify-center pad50-l">
          <div class="f30 lin-36 mar10-b text-left">{{ info.todayPointNum || 0 }}</div>
          <div class="f14 gray6">今日预估（积分）</div>
        </div>
        <div class="flex flex-column h120 justify-center pad50-l">
          <div class="f30 lin-36 mar10-b text-left">{{ info.weekPointNum || 0 }}</div>
          <div class="f14 gray6">本周预估（积分）</div>
        </div>
        <div class="flex flex-column h120 justify-center pad50-l">
          <div class="f30 lin-36 mar10-b text-left">{{ info.monthPointNum || 0 }}</div>
          <div class="f14 gray6">本月预估（积分）</div>
        </div>
        <div class="flex flex-column h120 justify-center pad50-l">
          <div class="f30 lin-36 mar10-b text-left">{{ info.yearPointNum || 0 }}</div>
          <div class="f14 gray6">本年预估（积分）</div>
        </div>
      </div>
    </div>
    <div class="bg-f5 lin-20 pad10-tb pad20-lr mar20-b">
      温馨提示：推荐返利积分是由您推荐的客户（旗舰店设置关系后）在农信数智官方旗舰店进行交易后，店铺返还给您的奖励，该积分在客户确认收货（交易完成）后自动发放，您可在积分所属的店铺进行采购抵扣货款。
    </div>
    <div class="flex items-center mar20-b">
      <div>时间：</div>
      <el-date-picker
        class="mar20_r"
        v-model="timeList"
        type="daterange"
        value-format="yyyy-MM-dd"
        range-separator="-"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
      >
      </el-date-picker>
      <div>订单状态：</div>
      <el-select class="w240 mar20_r" v-model="search.orderStatus" placeholder="请选择订单状态">
        <el-option v-for="item in statusList" :key="item.id" :label="item.name" :value="item.id"> </el-option>
      </el-select>
      <div>
        <el-button type="primary" @click="searchList">查询</el-button>
      </div>
    </div>
    <div class="flex items-center text-center bg-f5 h40 mar10-b">
      <div class="flex-auto">货品信息</div>
      <div class="w200">订单金额</div>
      <div class="w200">
        <span>返利积分</span>
        <el-tooltip class="item" effect="dark" content="返利总额为预估返利，实际返利积分以客户确认收货后为准" placement="top">
          <i class="el-icon-question pointer"></i>
        </el-tooltip>
      </div>
      <div class="w200">订单状态</div>
    </div>
    <template v-if="list.length">
      <div class="bor-gray" v-for="item in list" :key="item.id">
        <div class="bg-f5 h30 flex items-center">
          <span class="pad10-lr">订单编号：{{ item.orderId }}</span>
          <span class="pad10-lr">买家：{{ item.userName }}</span>
        </div>
        <div class="flex pad10-tb">
          <div class="flex-auto">
            <div class="flex" v-for="(good, index) in item.orderGoodsInfoList" :key="index">
              <!-- 货品 -->
              <div class="flex flex-auto pad20-l">
                <img class="good-img" :src="good.goodsPic" />
                <div class="flex flex-column justify-between pad10-l">
                  <div>{{ good.goodsName }}</div>
                  <div>规格：{{ good.goodsSpec }}</div>
                </div>
                <!-- 数量 -->
                <div class="w180 flex items-center justify-end">x{{ good.quantity }}</div>
              </div>
            </div>
          </div>
          <!-- 订单金额 -->
          <div class="w200 flex items-center justify-center">￥{{ item.fMoney }}</div>
          <!-- 积分返利 -->
          <div class="w200 flex items-center justify-center">{{ item.pointsNum }}</div>
          <!-- 状态 -->
          <div class="w200 flex items-center justify-center">{{ item.orderStatus }}</div>
        </div>
      </div>
      <div class="flex items-center mar40-t">
        <div class="gray9 flex-auto">共 {{ pageTotal }} 条记录 第 {{ pageNum }} / {{ totalPage }} 页</div>
        <el-pagination
          layout="prev, pager, next, sizes, jumper"
          background
          hide-on-single-page
          :page-size.sync="pageSize"
          :page-count="totalPage"
          :current-page.sync="pageNum"
          :page-sizes="[10, 50, 100]"
          @size-change="sizeChange"
          @current-change="currentChange"
        >
        </el-pagination>
      </div>
    </template>
    <div v-else class="pad30-tb bor-gray flex items-center justify-center">暂无订单</div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  data() {
    return {
      photoList: [],
      env: process.env,
      input: "",
      timeList: [],
      search: {
        timeStart: "",
        timeEnd: "",
        orderStatus: "",
      },
      // 2:已支付,3:已发货,4:已收货
      statusList: [
        {
          id: 2,
          name: "已支付",
        },
        {
          id: 3,
          name: "已发货",
        },
        {
          id: 4,
          name: "已收货",
        },
      ],

      list: [],

      pageSize: 10,
      pageNum: 1,
      totalPage: 1,
      pageTotal: 1,

      info: {},
    };
  },
  computed: mapState({
    userInfo: (state) => state.app.userInfo,
  }),
  created() {
    this.init();
    this.getList();
  },
  methods: {
    init() {
      // 累计
      this.$store
        .dispatch("channel/queryPointsByPtType", {
          type: 1,
          ptType: "RECOMMEND_REWARD_ADD_PT",
        })
        .then((data) => {
          const { recommendRewardNum } = data;
          this.info = {
            ...this.info,
            recommendRewardNum,
          };
        });
      // 获取预估 （本年，本月，本周，今日）
      this.$store.dispatch("channel/queryRecommendPointsMap").then((data) => {
        const { yearPointNum, monthPointNum, todayPointNum, weekPointNum } = data;
        this.info = {
          ...this.info,
          yearPointNum,
          monthPointNum,
          todayPointNum,
          weekPointNum,
        };
      });
    },
    consImg() {
      console.log("图片列表", this.photoList);
    },
    getList() {
      const { search, pageSize, pageNum } = this;
      console.log("search", search);
      this.$store
        .dispatch("channel/queryRecommendPointsOrderList", {
          ...search,
          pageSize,
          pageNum,
        })
        .then((data) => {
          console.log("订单", data);
          const { orderList, totalNum, totalPage } = data;
          const list = orderList || [];
          // .map((item) => {
          //   const { goodsName, goodsPic, goodsQuantity, goodsSpec } = item.orderGoodsList;
          //   const imgList = item.sellerVoucherImgUrl ? JSON.parse(item.sellerVoucherImgUrl) : [];
          //   return {
          //     ...item,
          //     goodsPic,
          //     goodsName,
          //     goodsSpec,
          //     goodsQuantity,
          //     sellerVoucherImgUrl: imgList,
          //   };
          // });
          this.list = list;
          this.totalPage = totalPage;
          this.pageTotal = totalNum;
        });
    },
    searchList() {
      const { timeList, search } = this;
      const timeStart = timeList.length ? timeList[0] : "";
      const timeEnd = timeList.length ? timeList[1] : "";
      this.search = {
        ...search,
        timeStart,
        timeEnd,
      };
      this.getList();
    },
    resetList() {
      this.timeList = [];
      this.pageNum = 1;
      this.pageSize = 30;
      this.search = {
        startTime: "",
        endTime: "",
        orderId: "",
        linkman: "",
      };
    },
    // 修改每页显示个数
    sizeChange(pageSize) {
      this.pageSize = pageSize;
      this.pageNum = 1;
      this.getList();
    },

    // 修改页码
    currentChange(pageNum) {
      this.pageNum = pageNum;
      this.getList();
    },

    openHome() {
      window.parent.postMessage(
        { fn: "open", data: { url: `${process.env.VUE_APP_APP}v/buyer/integral?isShowTitle=1&appid=2204261359350000109`, title: "积分明细", target: 0 } },
        "*"
      );
    },
  },
  // 监听器
  filters: {},
};
</script>

<style lang="scss" scoped>
@import "index";
</style>
<style>
.el-date-table td.today span,
.el-select-dropdown__item.selected,
.el-date-table td.available:hover {
  color: #0095f1;
}
.el-date-table td.start-date span,
.el-date-table td.end-date span {
  background-color: #0095f1;
}
</style>
